import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

export function Navigation() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav className="navbar">
            <div className="nav-container">
                <Link to="/" className="nav-logo">
                    ♟ Chess App
                </Link>

                <button
                    className="nav-toggle"
                    onClick={toggleMenu}
                    aria-label="Toggle menu"
                >
                    <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
                </button>

                <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
                    <li className="nav-item">
                        <Link
                            to="/"
                            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                            onClick={() => setIsMenuOpen(false)}
                        >
                            Игра с ботом
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link
                            to="/puzzle"
                            className={`nav-link ${location.pathname === '/puzzle' ? 'active' : ''}`}
                            onClick={() => setIsMenuOpen(false)}
                        >
                            Задачи
                        </Link>
                    </li>
                </ul>
            </div>
        </nav>
    );
}
